import React from "react";
import { Container, Typography, Box } from "@material-ui/core";

function PrivacyPolicy() {
  return (
    <div style={{ backgroundColor: "#fffdf8", minHeight: "100vh", width: "100%",fontFamily: "'Lato', sans-serif" }}>
    <Container style={{ padding: "40px 20px", maxWidth: "1000px"}}>
      <Box mb={4} textAlign="center">
        <Typography style={{ paddingTop: "80px", fontFamily: "'Lato', sans-serif", fontWeight:"bold", fontSize:'80px'}} variant="h3" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Effective Date: February 25, 2025
        </Typography>
      </Box>

      <Box mb={3}>
        <Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} paragraph>
          Welcome to Wolfe. Your privacy is important to us, and this Privacy Policy explains how we collect, use, store, and share your information when you use our services. By using Wolfe, you agree to the practices outlined below.
        </Typography>
      </Box>

      <Box mb={3}>
        <Typography style={{fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize:'25px' }} variant="h5" gutterBottom>
          1. Information We Collect
        </Typography>
        <Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}  paragraph>
          We may collect the following types of information:
        </Typography>
        <ul>
          <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} ><strong>Information You Provide:</strong>  When you sign up, communicate with us, or use our services, we may collect personal details such as your name, email, and other necessary account information.</Typography></li>
          <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} ><strong>Usage Data:</strong>  We may collect data about your interactions with Wolfe, including log data, device information, and activity patterns.</Typography></li>
          <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} ><strong>AI Interactions: </strong> As Wolfe is powered by AI, we collect inputs (queries) and outputs (AI-generated responses) to enhance user experience and improve our models. However, we do not use your data to train models.</Typography></li>
          <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} ><strong>Cookies and Tracking Technologies: </strong> We use cookies and similar technologies to enhance your experience, improve our services, and analyze usage patterns.</Typography></li>
        </ul>
      </Box>

      <Box mb={3}>
        <Typography style={{fontFamily: "'Lato', sans-serif", fontWeight: 600,fontSize:'25px' }} variant="h5" gutterBottom>
          2. How We Use Your Information
        </Typography>
        <ul>
          <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} >To provide, maintain, and improve Wolfe’s AI-powered services.</Typography></li>
          <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} >To personalize user experiences and deliver relevant content.</Typography></li>
          <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} >To ensure security, detect fraud, and comply with legal obligations.</Typography></li>
          <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} >To communicate with you about service updates, features, or policies.</Typography></li>
          <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} >To troubleshoot issues and enhance the performance of our AI.</Typography></li>
        </ul>
      </Box>

      <Box mb={3}>
        <Typography style={{fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize:'25px' }} variant="h5" gutterBottom>
          3. End-to-End Encryption
        </Typography>
        <Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}  paragraph>
          Wolfe is designed with end-to-end encryption to ensure the privacy and security of user data. Your interactions are encrypted to prevent unauthorized access.
        </Typography>
      </Box>

      <Box mb={3}>
        <Typography style={{fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize:'25px' }} variant="h5" gutterBottom>
          4. Data Sharing and Disclosure
        </Typography>
        <Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}  paragraph>
          We do not sell your personal data. However, we may share information:
        </Typography>
        <ul>
          <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} ><strong>With Service Providers:</strong>  Third-party vendors that help us operate and improve Wolfe, including AI infrastructure providers.</Typography></li>
          <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} ><strong>For Legal Compliance:</strong>  If required by law or to protect our rights.</Typography></li>
          <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} ><strong>In Business Transfers:</strong>  If Wolfe is involved in a merger, acquisition, or asset sale.</Typography></li>
        </ul>
      </Box>

      <Box mb={3}>
        <Typography style={{fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize:'25px' }} variant="h5" gutterBottom>
          5. Data Retention
        </Typography>
        <Typography  style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}  paragraph>
          We retain your information only as long as necessary to fulfill the purposes described in this policy, comply with legal obligations, and resolve disputes.
        </Typography>
      </Box>

      <Box mb={3}>
        <Typography style={{fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize:'25px' }} variant="h5" gutterBottom>
          6. Your Rights and Choices
        </Typography>
        <Typography  style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}  paragraph>
          You have rights over your data, including accessing, updating, or deleting your personal information and opting out of certain data collection practices, such as cookies. Contact us for any privacy-related concerns a support@hellowolfe.com.
        </Typography>
      </Box>

      <Box mb={3}>
        <Typography style={{fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize:'25px' }} variant="h5" gutterBottom>
          7. Security Measures
        </Typography>
        <Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}  paragraph>
          We implement appropriate security measures to protect your data from unauthorized access or misuse. However, no system is completely secure, and we cannot guarantee absolute security.
        </Typography>
      </Box>

      <Box mb={3}>
        <Typography style={{fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize:'25px' }} variant="h5" gutterBottom>
          8. Changes to This Policy
        </Typography>
        <Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}  paragraph>
          We may update this Privacy Policy periodically. Any significant changes will be communicated to you through Wolfe’s platform or other appropriate channels.
        </Typography>
      </Box>

      <Box mb={3}>
        <Typography style={{fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize:'25px' }}  variant="h5" gutterBottom>
          9. Contact Us
        </Typography>
        <Typography  style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}  paragraph>
          If you have any questions about this Privacy Policy, please contact us support@hellowolfe.com.
        </Typography>
      </Box>
    </Container>
    </div>
  );
}

export default PrivacyPolicy;
